<section class="main-content" fxLayout="column" fxLayoutAlign="center">
  <h1>Error</h1>
  <mat-card class="error-card">
    <p>The application has encountered the following critical error:</p>
    <br>
    <p class="red">{{errorMessage}}</p>
  </mat-card>
</section>

